import { Injectable } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material'

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component'
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component'
import { CropDialogComponent } from '../crop-dialog/crop-dialog.component'
import { ShareDialogComponent } from '../share-dialog/share-dialog.component'

import { Observable } from 'rxjs/Observable'

@Injectable()
export class DialogService {

  constructor(private dialog: MdDialog) { }

  public alert(title: string, message: string): Observable<boolean> {
    const dialogRef: MdDialogRef<AlertDialogComponent> = this.dialog.open(AlertDialogComponent)
    dialogRef.componentInstance.title = title
    dialogRef.componentInstance.message = message

    // if (buttonText) {
    //   dialogRef.componentInstance.buttonText = buttonText
    // }

    return dialogRef.afterClosed()
  }

  public confirm(title: string, message: string): Observable<boolean> {
    const dialogRef: MdDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent)
    dialogRef.componentInstance.title = title
    dialogRef.componentInstance.message = message

    return dialogRef.afterClosed()
  }

  public crop(title: string, image: File): Observable<File> {
    const dialogRef: MdDialogRef<CropDialogComponent> = this.dialog.open(CropDialogComponent, {
      width: '100vw',
      height: '100vh'
    })
    dialogRef.componentInstance.title = title
    dialogRef.componentInstance.image = image

    return dialogRef.afterClosed()
  }

  public share(): Observable<any> {
    const dialogRef = this.dialog.open(ShareDialogComponent)
    return dialogRef.afterClosed()
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/dialog/shared/dialog.service.ts